import { useContext, useEffect, useState } from 'react'
import { ConfigProvider } from 'antd'
import { useRoutes } from 'react-router-dom'
import { UserRoleEnum } from './generated/api'
import {
  AccountantLeadRoutes,
  AccountantRoutes,
  AdminRoutes,
  OperationLeadRoutes,
  OperationRoutes,
  PublicRoutes,
  WarehouseRoutes,
} from './routes'
import { UserContext } from 'context/UserContext'
import locale from 'antd/locale/id_ID'

import 'moment/locale/id'
import 'assets/scss/main.scss'
import 'react-quill/dist/quill.snow.css'

export const App = (): React.JSX.Element => {
  const [state] = useContext(UserContext)
  const [rendered, setRendered] = useState(false)
  const bearerToken = state.token

  const checkRoutesByRole = (userRole: UserRoleEnum | undefined) => {
    switch (userRole) {
      case UserRoleEnum.WarehouseOfficer:
        return WarehouseRoutes
      case UserRoleEnum.Operation:
        return OperationRoutes
      case UserRoleEnum.FinanceAccountant:
        return AccountantRoutes
      case UserRoleEnum.Administrator:
        return AdminRoutes
      case UserRoleEnum.OperationLead:
        return OperationLeadRoutes
      case UserRoleEnum.FinanceLead:
        return AccountantLeadRoutes
      default:
        return PublicRoutes
    }
  }
  const appRoutes = useRoutes(bearerToken ? checkRoutesByRole(state.userInfo?.role) : PublicRoutes)

  useEffect(() => {
    setRendered(true)
  }, [state])

  return (
    <ConfigProvider
      locale={locale}
      theme={{
        token: {
          colorError: '#F82416',
          colorPrimary: '#3C5337',
          colorBorder: '#C5C6CC',
        },
        components: {
          Button: {
            colorPrimary: '#3C5337',
            colorBgContainerDisabled: '#CDD5DF',
            colorTextDisabled: '#9AA4B2',
            colorPrimaryHover: '#63755F',
          },
          Table: {
            rowSelectedBg: '#fff',
            rowSelectedHoverBg: '#fff',
          },
          Tabs: {
            horizontalMargin: '0',
          },
          Form: {
            labelFontSize: 12,
          },
        },
      }}
    >
      {rendered && appRoutes}
    </ConfigProvider>
  )
}
